import ContentSearch from "@/views/console/ContentSearch";
import C from "@/utils/constants";

export default [
  {
    path: "content-search",
    component: ContentSearch,
    meta: {
      roles: [
        C.ROLE.ADMIN,
        C.ROLE.MANAGER,
        C.ROLE.QA_TEAM,
        C.ROLE.CSR_SUPERVISOR,
      ],
    },
    children: [
      {
        path: "",
        name: "content-search",
        component: () =>
          import(
            "../components/console/dynamic-content/content-search/ContentSearch"
          ),
        meta: {
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.MANAGER,
            C.ROLE.CSR_SUPERVISOR,
            C.ROLE.AGENT_ENGAGEMENT,
          ],
        },
      },
      {
        path: "view/:id",
        name: "edit-content",
        components: {
          default: () =>
            import(
              "../components/console/dynamic-content/content-search/ContentSearch"
            ),
          view: () =>
            import(
              "../components/console/dynamic-content/content-search/ContentEditDialog"
            ),
        },
        props: {
          view: (route) => {
            return {
              mode: "view",
              contentId: route.params.id,
              parent: "content-search",
            };
          },
        },
        meta: {
          roles: [
            C.ROLE.ADMIN,
            C.ROLE.MANAGER,
            C.ROLE.QA_TEAM,
            C.ROLE.CSR_SUPERVISOR,
            C.ROLE.AGENT_ENGAGEMENT,
          ],
        },
      },
    ],
  },
];
